/** @format */

import * as React from 'react';
import { formatDistance } from 'date-fns';

export const Comment = ({ data }) => {
  return (
    <div className="comment">
      <div className="comment-header">
        {/* <div className="comment-name">
          <img src={data.avatar} alt="" />
          <span>{data.name}</span>
        </div> */}
        <div className="comment-date">{formatDistance(new Date(data.createdon), new Date(), { addSuffix: true })}</div>
      </div>
      <div className="comment-detail" dangerouslySetInnerHTML={{ __html: data.notetext }} />
    </div>
  );
};
